import { searchProduct } from "src/services/invoice-api"; //M10-14632

interface OrderedDataProps {
  orderData: any;
  invoiceData?: any
}

const InvoiceApprovalOrderedData = ({ orderData, invoiceData }: OrderedDataProps) => {
  return (
    <div>
      <div className="mt-10 border mx-[3.75rem] border-[#d0d0d0] p-5 rounded-xl px-10">
        <div className="flex justify-between items-center pb-5">
          <p className="text-lg font-semibold">Mapped Data</p>
        </div>

        <table className="min-w-full border border-gray-200">
          <thead className="w-full bg-gray-100">
            <tr>
              <th className="px-4 py-2 text-sm text-left text-gray-600">S.No</th>    {/* M10-9670 */}
              <th className="px-4 py-2 text-sm text-left text-gray-600">Item Code</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Order Code</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Item description</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Inv. MRP</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Inv. PTR</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Price</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Inv. Qty.</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Gross Amt.</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Price Identifier</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Discount %</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Cash Discount %</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Scheme Qty.</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">GST % </th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">Batch</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">PO Generated</th>
              <th className="px-4 py-2 text-sm text-left text-gray-600">PO Number</th>
            </tr>
          </thead>
          <tbody>
            {orderData?.map((item: any, index: any) => (
              <tr key={index} className={index % 2 === 0 ? "bg-gray-50 text-sm h-12" : "text-sm h-12"}>
                <td className="px-4 py-2 border-t">{index + 1}</td>    {/* M10-9670 */}
                {/* M10-14632 */}
                <td className="px-1 py-2 border-t">
                  {item?.is_item_unknown ? (
                    item?.item_code
                  ) : (
                    <span
                      className="text-[#7F56D9] cursor-pointer hover:underline"
                      onClick={async () => {
                        try {
                          const res = await searchProduct({
                            search: item?.item_code,
                            page: 1,
                            perPage: 10,
                            company_code: invoiceData?.company_code,
                          });
                          const matched = res?.data?.data?.find(
                            (p: any) => p.item_code === item?.item_code
                          );
                          if (matched?.company_productcode) {
                            window.sessionStorage.setItem("detailsId", String(matched.company_productcode));
                            window.sessionStorage.setItem("product_activeStatus", matched.active_status ?? "");
                            window.open("/masters/products/details", "_blank");
                          }
                        } catch (e) {
                          console.error(e);
                        }
                      }}
                    >
                      {item?.item_code}
                    </span>
                  )}
                </td>
                {/* M10-14632 */}
                <td className="px-4 py-2 border-t">
                  <a
                    className="text-gray-900 hover:text-[#6b40d6] w-fit"
                    href={`/transactions/orders/info/${item?.orderProduct?.order?.order_code}/1`}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                      window.localStorage.setItem("counterCompanyLocationId", invoiceData?.counter_company_location_id);
                      window.localStorage.setItem("company_code", invoiceData?.company_code);
                    }}
                  >
                    {item?.orderProduct?.order?.order_code}
                  </a>
                </td>
                <td className="px-4 py-2 border-t">{item?.item_description}</td>
                <td className="px-4 py-2 border-t">{item?.inv_mrp}</td>
                <td className="px-4 py-2 border-t">{item?.ptr}</td>
                <td className="px-4 py-2 border-t">{item?.orderProduct?.price_identifier == 3 ? item?.fixed_price : item?.ptr}</td>
                <td className="px-4 py-2 border-t">{item?.quantity}</td>
                <td className="px-4 py-2 border-t">{Number(item?.gross_amt).toFixed(2)}</td>
                <td className="px-4 py-2 border-t">{item?.orderProduct?.price_identifier == 1 ? "Discount on PTR" : item?.orderProduct?.price_identifier == 2 ? "Scheme" : "Fixed Price"}</td>
                <td className="px-4 py-2 border-t">{Number(item?.discount_perc).toFixed(2)}</td>
                <td className="px-4 py-2 border-t">{item?.p_cash_discount_perc || "-"}</td>
                <td className="px-4 py-2 border-t">{item?.free_qty || 0}</td>
                <td className="px-4 py-2 border-t">{item?.p_gst_perc || 0}</td>
                <td className="px-4 py-2 border-t">{item?.batch_no || "-"}</td>
                <td className="px-4 py-2 border-t">{item?.is_po_generated !== undefined ? (item?.is_po_generated ? 'Yes' : 'No') : '-'}</td>
                <td className="px-4 py-2 border-t">{item?.po_item?.purchaseOrder?.po_number ? item?.po_item?.purchaseOrder?.po_number : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InvoiceApprovalOrderedData;
